import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';
import { PhoneField } from 'shared/ui/PhoneField';

export const AdditionalPhone: FC<IFieldFactoryProps> = (props) => {
  const { type } = props;
  const validate = useValidateOnBlur(type, true);

  return (
    <PhoneField
      {...props}
      onBlur={validate}
    />
  );
};
